import * as React from "react"

const SvgDownArrowMenu = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19.219}
    height={11.87}
    viewBox="0 0 19.219 11.87"
    {...props}
  >
    <path
      d="M18.37.278 9.797 9.654.987.887"
      fill="none"
      stroke="#e32223"
      strokeWidth={1.99922}
    />
  </svg>
)

export default SvgDownArrowMenu
